import Form from '../../lib/forms'

class FlyoutForm {
  constructor () {
    if (window.flyoutForm) return
    this.main = document.querySelector('main')
    this.prefix = '.c-flyoutForm'
    this.formTools = new Form(this.prefix)
    this.formTools.init()
    this.section = document.querySelector(this.prefix)
    this.formOpenButton = document.getElementById('toggle-flyout-form')
    this.closeButton = document.getElementById('close-flyout-form')
    this.heroOpenButton = document.getElementById('hero-home-more-info')
    this.init()
  }

  init () {
    const main = this.main
    const section = this.section
    const formOpenButton = this.formOpenButton
    const closeButton = this.closeButton
    const heroOpenButton = this.heroOpenButton

    const hideForm = () => {
      section.classList.remove('isOpen')
      formOpenButton.classList.remove('isOpen')
      main.classList.remove('isBlurred')
    }

    const showForm = () => {
      section.classList.add('isOpen')
      formOpenButton.classList.add('isOpen')
      main.classList.add('isBlurred')
    }

    const handleClosure = event => {
      return (!section.contains(event.target) && event.target !== heroOpenButton) && hideForm()
    }

    if (section === null) return

    if (formOpenButton !== null) {
      formOpenButton.addEventListener('click', () => {
        showForm()
      })
    }

    if (heroOpenButton !== null) {
      heroOpenButton.addEventListener('click', () => {
        showForm()
      })
    }

    if (closeButton !== null) {
      closeButton.addEventListener('click', () => {
        hideForm()
      })
    }

    window.addEventListener('click', handleClosure)
    window.addEventListener('focusin', handleClosure)
  }
}

export default FlyoutForm
